"use strict";
// Form and project status enumerations. Merged from backend pm/types and
// backend/frontend `types/enums.ts`.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrbanAnalysisStatus = exports.ProjectStatus = exports.isFormChecked = exports.isFormCancelled = exports.isFormRefused = exports.isFormValidated = exports.FormStatus = void 0;
exports.FormStatus = {
    EMPTY: 'EMPTY',
    EDITED: 'EDITED',
    COMPLETED: 'COMPLETED',
    VALIDATED: 'VALIDATED',
    REFUSED: 'REFUSED',
    // Only an urban study reaches this today (#695): the party who ordered it
    // called it off before it was accepted. It is a terminal state — a cancelled
    // study is never worked on, accepted or refused again — and it lives in the
    // shared enum because `urban_analysis.status` IS a `project_form_status`
    // column, the very same one every other form status is written to.
    CANCELLED: 'CANCELLED',
};
// Status predicates shared by the synthesis UI (frontend) and the assistant
// predicates (backend) so "is this form done" is answered identically on both
// sides instead of via hard-coded 'VALIDATED' / 'REFUSED' string checks.
const isFormValidated = (status) => status === exports.FormStatus.VALIDATED;
exports.isFormValidated = isFormValidated;
const isFormRefused = (status) => status === exports.FormStatus.REFUSED;
exports.isFormRefused = isFormRefused;
// Called off by whoever ordered it, before anyone accepted it (#695).
const isFormCancelled = (status) => status === exports.FormStatus.CANCELLED;
exports.isFormCancelled = isFormCancelled;
// "Checked" = a reviewer has acted on the form, whether they accepted
// (VALIDATED) or rejected (REFUSED) it.
const isFormChecked = (status) => (0, exports.isFormValidated)(status) || (0, exports.isFormRefused)(status);
exports.isFormChecked = isFormChecked;
exports.ProjectStatus = {
    DRAFT: 'DRAFT',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
exports.UrbanAnalysisStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
};
//# sourceMappingURL=status.js.map